"use client";
import React, { useEffect, useState } from "react";
import Modal from 'react-modal';
import ApplicationForm from "./ApplicationForm";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import service from '../../../../config';
interface Vacancy {
  type: string;
  location: string;
  title: string;
  description: string;
}

interface VacancySectionProps {
  vacancies: Vacancy[];
}
export interface FormValues {
  name: string;
  email: string;
  mobile: string;
  document: File | null;
  post: string;
}

const VacancySection: React.FC<VacancySectionProps> = ({ vacancies }) => {
  const [formData, setFormData] = useState<FormValues>({
    name: '',
    email: '',
    mobile: '',
    document: null,
    post: ''
  });
  const [isShowToast, setIsShowToast] = useState<boolean | null>(false);
  const [selectedVacancyIndex, setSelectedVacancyIndex] = useState<number | null>(null);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value, post: vacancies[selectedVacancyIndex]?.title });
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files[0];
    setFormData({ ...formData, document: file });
  };
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formDataWithFile = new FormData();
    let obj = {
      name: formData?.name,
      email: formData?.email,
      mobile: formData?.mobile,
      post: formData?.post,
    }
    formDataWithFile.append("data", JSON.stringify(obj));
    formDataWithFile.append("document", formData.document);
    try {
      const response = await fetch(service?.API_URL+'/api/mail/application-mail', {
        method: 'POST',
        headers: {
          // 'Content-Type': 'application/json',
        },
        body: formDataWithFile,
      });
      if (response.ok) {
        const data = await response.json();
        setIsShowToast(true);
        toast.success("Data submited succesfully", { toastId: 'success' })
        closeModal();
        //it clear the input field when data is submited successfully
      } else {
        const errorData = await response.json();
        setIsShowToast(true);
        toast.error("Please Enter Details", { toastId: 'error' })
          closeModal();
      }
    } catch (error) {
      setIsShowToast(true);
      toast.error("Failed to submit form", { toastId: 'error' })
    }
  };
  const openModal = (index: number) => {
    setSelectedVacancyIndex(index);
    document.querySelector("body").classList.add("disable-scroll");
  };

  const closeModal = () => {
    setSelectedVacancyIndex(null);
    document.querySelector("body").classList.remove("disable-scroll");
    setFormData({
      name: '',
      email: '',
      mobile: '',
      document: null,
      post: ''
    });
  };
  useEffect(() => {
    if (isShowToast) {
      setTimeout(() => {
        setIsShowToast(false);
      }, 2000)
    }
  }, [isShowToast])

  return (

    <>
      <ToastContainer
        position="top-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <section id="apply-now" className="mil-careers" style={{paddingTop:"20px", paddingBottom:"30px"}}>
        <div className="container">
        <header className="mil-accent mil-h2 col-md-6 col-xl-6" style={{marginBottom:"20px"}}>Current Openings</header>
          <ul className="mil-vacancies-frame">
            <li className="row">
              <p className="mil-h4"><a id="job-openings">No Current Openings!</a></p>
            </li>
            {/* {vacancies.map((vacancy, index) => (
              <li key={index} className="mil-vacancy">
                <div className="row">
                  <div className="col-md-6 col-lg-4 col-xl-3 ">
                    <div className="mil-vacancy-head mil-mb-15">
                      <span className="mil-badge mil-font-2">{vacancy?.type}</span>
                      <span className="mil-text-sm mil-dark mil-font-2">{vacancy?.location}</span>
                    </div>
                    <h4 className="mil-h4">{vacancy?.title}</h4>
                  </div>
                  <div className="col-md-6 col-lg-4 col-xl-5  mil-dig-text">
                    <p style={{textAlign:"justify"}}>{vacancy?.description}</p>
                  </div>
                  <div className="col-md-12 col-lg-4 col-xl-4 m-auto">
                    <div className="mil-adaptive-right">
                      <button onClick={() => openModal(index)} className="mil-button mil-border my-4">
                        <span>Apply Now</span>
                      </button>
                    </div>
                  </div>
                </div>
              </li>
            ))} */}
          </ul>
        </div>
        <Modal
          isOpen={selectedVacancyIndex !== null}
          onRequestClose={closeModal}
          ariaHideApp={false}
          contentLabel="Apply Now Modal"
          className="ReactModal__Overlayt"
          overlayClassName="custom-overlay"
        >
          <ApplicationForm
            title={vacancies[selectedVacancyIndex]?.title}
            closeModal={closeModal}
            handleSubmit={handleSubmit}
            handleChange={handleChange}
            handleFileChange={handleFileChange}
            formData={formData}
          />
        </Modal>
      </section>
    </>
  );
};

export default VacancySection;
